export const appConfig = {
    frontendMsalClientId: '2d321975-3660-4e79-8b3f-71531da02a7a',
    frontendMsalApiScope: 'https://admin.teresacare.nl/api/Tenant.Read',
};
